export default "__VITE_ASSET__c1PyzLs8__"